import { Injectable } from "@angular/core";
import { RegistrationApiService } from "./registration-api.service";
import { ItalianProvince, ItalianTown } from "../models/data-model";

@Injectable()
export class ItalianTownsService {

    constructor(
        private readonly registrationApiService: RegistrationApiService
    ) { }

    getProvinces(): Promise<ItalianProvince[]> {
        return this.registrationApiService.getItalianProvinces();
    }

    getTownsByProvince(province: string): Promise<ItalianTown[]> {
        return this.registrationApiService.getItalianTownsByProvince(province);
    }

}
